module.exports = __webpack_public_path__ + "media/images/Vectorgreen-7258059d.png";